import type { GetReadProductResponse } from '@/services/WarrantyApiService/types'
import WarrantyApiService from '@/services/WarrantyApiService/WarrantyApiService'
import { useQuery } from '@tanstack/vue-query'
import type { Ref } from 'vue'

type ResponseData = GetReadProductResponse

export const useFetchProduct = (productCode: Ref<string>) => {
  return useQuery<ResponseData>({
    queryKey: ['fetch-data-read-product'],
    queryFn: async () => {
      const response = await WarrantyApiService.getReadProduct(productCode.value)

      if (response.isWrong()) {
        const error = new Error(response.value.message)
        error.name = response.value.name
        throw error
      }

      return {
        serialNumber: response.value.serialNumber,
        description: response.value.description,
        size: response.value.size,
        year: response.value.year,
        primaryColorHex: response.value.primaryColorHex,
        secondaryColorHex: response.value.secondaryColorHex,
        loadedAt: response.value.loadedAt ? new Date(response.value.loadedAt) : undefined
      }

      // return {
      //   serialNumber: '1234',
      //   productUnitId: 'dh27dgeh',
      //   description: 'description',
      //   size: 'Large',
      //   year: '2024',
      //   primaryColorHex: '',
      //   secondaryColorHex: '',
      //   loadedAt: new Date()
      // }
    },
    retry: false,
    enabled: false
  })
}
